import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import {
  BREAKPOINTS,
  PROFILE_BOTTOM_HEIGHT,
  STICKY_NAV_SCROLL_MARGIN
} from '../../lib/constants';

import { Card } from '../CardContainer/styles';
import { ProviderBadges as ProviderBadgesComp } from '@kyruus/provider-components';

// TODO: bring back in react-sticky-box once PMC webpack is upgraded
// https://kyruus.jira.com/browse/KENG-33796
export const BookingPanelStickyBox = styled('div')`
  // desktop only sticky box
  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    position: sticky;
    top: 74px;
    height: 100vh;
    overflow-y: auto;

    /* Handle iframe scenario, ie CCF */
    body(.in-iframe) & {
      height: 100%;
      position: static;
      top: unset;
    }
  }
`;

export const ProfileContainer = styled('div')`
  @media screen {
    display: grid;
  }
  grid-template-areas: 'intro' 'content';
  grid-template-columns: 1fr;

  padding-bottom: ${PROFILE_BOTTOM_HEIGHT};
  font-family: ${fromTheme('font_face')};
  background: ${(props) =>
    fromTheme('provider_profile_color_background')(props)};

  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    grid-row-gap: ${fromTheme('spacing_large')};
    grid-column-gap: ${fromTheme('spacing_xlarge')};
  }

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    gap: ${fromTheme('spacing_large')};
    grid-template-areas: 'intro intro' 'profile-nav profile-nav' 'content action';
    grid-template-columns: 3fr minmax(325px, 1.25fr);
    padding-bottom: 0;
    & #profile-main-content :focus,
    & #schedule-appointment-aside :focus {
      scroll-margin-top: ${STICKY_NAV_SCROLL_MARGIN};
    }
  }
`;

export const Content = styled('div')`
  grid-area: content;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const ProfileNavigationContainer = styled('div')`
  @media screen and (max-width: ${BREAKPOINTS.large - 1}px) {
    display: none;
  }
  grid-area: profile-nav;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 900;
  background: ${fromTheme('provider_profile_color_background')};
  // override styles in the DropdownTabs component
  & nav {
    padding: 0;
    border: none;
    border-bottom-width: ${(props) =>
      fromTheme('provider_profile_border_width')(props) ||
      fromTheme('border_width')(props)};
    border-bottom-style: ${(props) =>
      fromTheme('provider_profile_border_style')(props)};
    border-bottom-color: ${(props) =>
      fromTheme('provider_profile_color_border')(props)};
    background: ${fromTheme('provider_profile_color_background')};
    border-radius: 0;
    align-items: flex-end;
  }
  & nav > a {
    background: ${fromTheme('provider_profile_color_background')};
  }
`;

export const ProfileCenterMeta = styled('div')`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
  gap: ${fromTheme('spacing_medium')} ${fromTheme('spacing_small')};
  align-items: center;
  justify-content: center;
  height: fit-content;
  padding: ${(props) => {
    const space = fromTheme('spacing_medium')(props);
    return `0 ${space} ${space} ${space}`;
  }};
  /*&&& > * {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;
  }*/

  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    align-items: flex-start;
    justify-content: center;
    /*&&& > * {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: flex-start;
    }*/
  }
`;

export const ProfileCenterTopContainer = styled('div')`
  grid-area: intro;
  gap: ${fromTheme('spacing_medium')};
  display: flex;
  flex-direction: column;
  position: relative;

  margin-bottom: ${fromTheme('spacing_large')};
  text-align: center;
  border-radius: ${(props) =>
    fromTheme('provider_profile_border_radius')(props)};
  border: ${(props) =>
    `${fromTheme('provider_profile_border_style')(props)} ${fromTheme(
      'provider_profile_color_border'
    )(props)} ${fromTheme('provider_profile_border_width')(props)}`};
  box-shadow: ${(props) => fromTheme('provider_profile_box_shadow')(props)};
  -webkit-box-shadow: ${(props) =>
    fromTheme('provider_profile_box_shadow')(props)};
  -moz-box-shadow: ${(props) =>
    fromTheme('provider_profile_box_shadow')(props)};

  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    flex-direction: row;
    margin: 0 0 -${fromTheme('spacing_small')} 0;
    padding: 0;
    text-align: initial;
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const MobileAvailabilityContainer = styled(Card)`
  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: none;
  }
  margin: 0 0 ${fromTheme('spacing_xlarge')} 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${fromTheme('spacing_xlarge')};
  border: none;
  background: none;
`;

export const ProviderInfoWrapper = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  gap: ${fromTheme('spacing_medium')};
  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    flex-flow: row wrap;
  }
`;

export const ProviderBadges = styled(ProviderBadgesComp)`
  overflow: visible;
  height: auto;
  justify-content: center;
  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    justify-content: flex-start;
  }
  & > div {
    height: 3ch;
  }
`;

export const ProfileSectionWrapper = styled('div')`
  margin-bottom: ${fromTheme('spacing_xlarge')};

  // negative offset to account for padding scrolling section headings into view
  padding-top: ${fromTheme('spacing_xxlarge')};
  margin-top: -${fromTheme('spacing_xxlarge')};
`;

export const ShowContactInMobileWrapper = styled(ProfileSectionWrapper)`
  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    display: none;
  }
`;

export const ShowContactInMobile = styled(Card)`
  > div {
    border: none;
    padding: 0;
    margin: 0;
  }
`;
